import { useEffect } from 'react'

import { formatDate } from 'utils/formatters'

/**
 * Appends app meta data (version and build time) to the document head
 */
export const useAppDocMetaData = ({ version, buildTime }: { version: string; buildTime: any }) => {
  useEffect(() => {
    document.head.prepend(document.createComment(`App version: ${version}`))
    document.head.prepend(document.createComment(`Build time: ${formatDate(buildTime)}`))
  }, [buildTime, version])
}
